
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 20 29.022"><path fill="#06ac38" d="M4.262 21.294v7.728H0v-7.728ZM8.519 0c3.652.004 5.235.211 7.484 1.426C18.474 2.753 20 5.39 20 8.673c0 3.052-1.244 5.689-3.632 7.264-2.189 1.46-4.676 1.658-7.993 1.658H0V0Zm.683 3.73-.13.001-4.81.034v10.149h5.091c3.566 0 6.285-1.426 6.285-5.19 0-3.5-2.189-5.026-6.567-4.993z"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    